import { render, staticRenderFns } from "./RecordExitingStatusNotification.vue?vue&type=template&id=745951a0&scoped=true&"
import script from "./RecordExitingStatusNotification.vue?vue&type=script&lang=js&"
export * from "./RecordExitingStatusNotification.vue?vue&type=script&lang=js&"
import style0 from "./RecordExitingStatusNotification.vue?vue&type=style&index=0&id=745951a0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "745951a0",
  null
  
)

export default component.exports